import angular from 'angular';
import swoaConstants from '../../app.constants';
import swoaDate from '../../components/date/date.filter';
import htmlTemplate from './person-search-details-table.html';

export default angular
  .module('swoa.person.person-search-details-table', [swoaConstants, swoaDate])
  .component('swoaPersonSearchDetailsTable', {
    template: htmlTemplate,
    bindings: {
      personDetailList: '<',
      selectedPerson: '=',
      withoutSelection: '<',
      withCardInfo: '<'
    },
    controller: PersonSearchDetailsTableController,
    controllerAs: 'vm'
  }).name;

/** @ngInject */
function PersonSearchDetailsTableController($scope) {
  const vm = this;

  vm.rowClicked = rowClicked;

  vm.$onInit = () => {
    activate();
  };

  // ////////////

  function activate() {
    $scope.$watch('vm.personDetailList', resetTable);
  }

  function resetTable() {
    vm.page = 1;
    if (!vm.withoutSelection) {
      vm.selectedPerson = null;
    }
  }

  function rowClicked(event, person) {
    if (!vm.withoutSelection) {
      event.preventDefault();
      event.stopPropagation();
      vm.selectedPerson = person.id;
    }
  }
}
